<div class="details mb-5">
  <fieldset class="margin-calculator">
    <legend>Calculate Margin</legend>
    <cnc-inline-margin-calculator [rfq]="rfq"></cnc-inline-margin-calculator>
  </fieldset>
</div>
